<template>
    <div class="select-box-type">
        <div class="select-box-type--first-col">
            <p class="select-box-type--first-col--text" @click="goToBumperBoxPage()">{{$t('BUMPER_BOX_SELECT_TYPE')}}</p>
        </div>
        <div class="select-box-type--second-col">
                <multiselect
                    v-if="displayProductOptions.length"
                    track-by="id"
                    class="select-box-type--second-col--select"
                    label="display_name"
                    placeholder=""
                    :show-labels="false"
                    :options="displayProductOptions"
                    openDirection="below"
                    @input="updateProductType"
                    v-model="activeBox"/>
        </div>
        <transition name="transitionFade">
            <bumper-box-upgrade-modal
                v-if="showUpgradeModal"
                :subscription="subscription"
                :selectedBox="selected"
                @closed="closeModal"/>
        </transition>
    </div>
</template>

<script>

import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';
import BumperBoxUpgradeModal from '@/components/partials/account/bumper-box/BumperBoxUpgradeModal';
import { PRODUCT_FAMILY_LITE } from '@/constants/Gifting';

export default {
    name: 'SelectBoxType',
    components: { Multiselect, BumperBoxUpgradeModal },
    props: {
        subscription: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            selected: null,
            showUpgradeModal: false,
        };
    },
    mounted() {
        if (!this.primaryProducts.length) this.$store.dispatch('subscription/fetchAvailableDeliveryDay');
    },
    computed: {
        ...mapGetters({
            getAddressById: 'address/getAddressById',
            primaryProducts: 'subscription/getProductTypes',
            // subscription: 'subscription/getActiveSubscription',
        }),
        displayProductOptions() {
            return this.showEssentialBox
                ? this.primaryProducts
                : this.primaryProducts.filter(item => item.product_family.toLowerCase() !== PRODUCT_FAMILY_LITE);
        },
        showEssentialBox() {
            return this.subscription?.show_essential_box;
        },
        subscriptionAddress() {
            return this.getAddressById(this.subscription.delivery_address_id) || {};
        },
        activeBox: {
            get() {
                return this.primaryProducts?.filter(item => item.product_family.toLowerCase() === this.subscription.product_family.toLowerCase())[0];
            },
            set(val) {
                this.selected = val;
            },
        },
    },
    methods: {
        goToBumperBoxPage() {
            this.$router.push({ name: 'account.bumper-box' });
        },
        updateProductType(val) {
            if (val.product_family === this.activeBox.product_family) return;
            this.showUpgradeModal = true;
        },
        getSelected() {
            return this.primaryProducts?.filter(item => item.product_family.toLowerCase() === this.subscription.product_family.toLowerCase())[0];
        },
        closeModal() {
            this.showUpgradeModal = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.select-box-type {
    display: flex;
    border-bottom: 1px solid #000000;
    justify-content: space-between;
    align-items: center;
    &--first-col {
        padding: 5px 15px;
        &--text {
            width: fit-content;
            position: relative;
            cursor: pointer;
            text-decoration: underline;
            text-decoration-color: #1a1a1a;
            text-decoration-thickness: 1px;
        }
        .info {
            background: #5ab5d9;
            width: 20px;
            height: 20px;
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 0;
            right: -30px;
            top: -10px;
            border-radius: 50%;
            cursor: pointer;
        }
    }
    &--second-col {
        &--select {
            max-width: 210px;
            border: none;
        }
    }
}
</style>

<style>
div.select-box-type--second-col--select div.multiselect__tags {
    border-width: 0px;
}
</style>
